import { render, staticRenderFns } from "./RoomHandle.vue?vue&type=template&id=4af09aa4&scoped=true&"
import script from "./RoomHandle.vue?vue&type=script&lang=js&"
export * from "./RoomHandle.vue?vue&type=script&lang=js&"
import style0 from "./RoomHandle.vue?vue&type=style&index=0&id=4af09aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af09aa4",
  null
  
)

export default component.exports